import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight, FileText } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-20 md:py-32" ref={ref} data-id="element-9">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="gradient-border rounded-2xl p-8 md:p-12 text-center" data-id="element-11">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-12">
            ¿Listo para transformar la identidad digital?
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-13">
            Únete a miles de organizaciones que ya confían en truid para
            proteger la identidad de sus usuarios mientras mejoran la
            experiencia digital.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-14">
            <button className="group bg-amber-500 hover:bg-amber-600 text-navy-900 px-8 py-4 rounded-lg font-semibold transition-all flex items-center space-x-2 shadow-lg shadow-amber-500/20 hover:shadow-amber-500/30" data-id="element-15">
              <span data-id="element-16">Solicitar demo</span>
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-17" />
            </button>
            <button className="group border-2 border-teal-500/30 hover:border-teal-500 text-white px-8 py-4 rounded-lg font-semibold transition-all flex items-center space-x-2" data-id="element-18">
              <FileText size={20} data-id="element-19" />
              <span data-id="element-20">Ver documentación</span>
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-8 pt-8 border-t border-teal-500/10" data-id="element-21">
            <p className="text-sm text-gray-500" data-id="element-22">
              Sin tarjeta de crédito • Configuración en minutos • Soporte 24/7
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}